import './Toolbar.scss';

export type ToolbarProps = {
	children?: string | React.ReactNode | React.ReactNode[];
};

const Toolbar: React.FC<ToolbarProps> = ({ children }) =>
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	!!children && <div className="toolbar">{children}</div>;

export default Toolbar;
